// Cars Data Props
export interface CarsDataType {
  vehicleBrand: VehicleBrand[];
}

// Vehicle Brand Props
export interface VehicleBrand {
  description:    string;
  vehicleBrandId: string;
  vehicleGroups:  VehicleGroup[];
}

// Vehicle Group Props
export interface VehicleGroup {
  description:    string;
  vehicleGroupId: string;
  vehicleModels:  string[];
}

// useGetCarsDataAlphabeticalOrder Props
interface Props {
  data: CarsDataType;
  keyProp: string;
}

// Get vehicle brands alphabetical ordered by key props
export const useGetCarsDataAlphabeticalOrder: ({ data, keyProp }: Props) => { vehicleBrand: VehicleBrand[] } = 
  ({ data, keyProp}) => {
    const { vehicleBrand } = data 
    const carsDataOrdered: VehicleBrand[] = vehicleBrand?.sort(( a: VehicleBrand, b: VehicleBrand ) => {
      if(a[keyProp as keyof VehicleBrand] < b[keyProp as keyof VehicleBrand]) { return -1; }
      if(a[keyProp as keyof VehicleBrand]> b[keyProp as keyof VehicleBrand]) { return 1; }
      return 0;
    })
    return { vehicleBrand: carsDataOrdered }
}